export default __webpack_public_path__ + "static/media/goto.7888bae3.svg";